<deprecated-labeled-field [help]="help" [label]="label" [required]="required">
  <div [ngClass]="classes">
    <ng-container *ngFor="let option of options; trackBy: byValue">
      <radio
        *ngIf="!option.locked"
        [identifier]="identifier + '-' + option.value"
        [inline]="true"
        [selected]="option.value === value"
        (changed)="$event && valueChange.emit(option.value)"
        [disabled]="disabled"
      >
        {{ option.label }}
      </radio>
      <radio
        *ngIf="option.locked"
        [identifier]="identifier + '-' + option.value"
        [inline]="true"
        [selected]="option.value === value"
        [disabled]="true"
        rivTooltip="You don't have permission to choose this option"
      >
        {{ option.label }}
        <riv-icon [name]="'Lock'" [size]="16"></riv-icon>
      </radio>
    </ng-container>
  </div>
  <ng-content></ng-content>
</deprecated-labeled-field>
